import { decBase64 } from './SecurityUtil';

// 本地时间减服务器的时间差(ms)
let localToServerTimeDiff = 0;

(Date.prototype as any).format = function (f: any) {
  const o: any = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds(),
  };

  if (/(y+)/.test(f)) {
    f = f.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  for (const k in o) {
    if (new RegExp('(' + k + ')').test(f)) {
      f = f.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }

  return f;
};

/**
 * 校正服务器时间
 * (仅在底层Request调用)
 */
export function correctionServerTime(serverTimeStr: string) {
  const localTimeStamp = Date.now();
  const serverTimestamp = new Date(serverTimeStr).getTime();
  if (serverTimestamp > 0) {
    // 获取到的服务器时间是有一个有效值
    localToServerTimeDiff = localTimeStamp - serverTimestamp;
  }
}

/**
 * 解析accessToken中的信息
 * @param accessToken
 * @returns {*} {type,expires,aid}
 */
export function parseAccessToken(accessToken: string) {
  const arr = accessToken.split('.');
  if (arr && arr.length && arr[1]) {
    return JSON.parse(decBase64(arr[1]));
  }
}

export function getClientHeader(): string {
  const arr = [];
  const ua = navigator.userAgent;
  const result = ua.match(/([^\(\)]+)(?=\))/g);
  // 匹配userAgent中第一个小括号的内容,并替换掉其中的“;”
  const info = result && result.length > 0 ? result[0].replace(/;/g, ',') : 'Other';
  // 客户端版本
  arr.push('QingTui/' + '52300');
  // 操作系统
  arr.push(info);
  // 机器型号
  arr.push('Web');
  // appCode
  arr.push('0');
  return arr.join(';');
  // 'QingTui/3601;Macintosh, Intel Mac OS X 10_12_6;Web;0';
}

/**
 * 获取服务器时间戳
 */
export function getServerTimestamp(): number {
  const localTimeStamp = Date.now();
  return localTimeStamp - localToServerTimeDiff;
}
